import { render, staticRenderFns } from "./UtangPayments.vue?vue&type=template&id=14533e24"
import script from "./UtangPayments.vue?vue&type=script&lang=js"
export * from "./UtangPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports